module.exports = __webpack_public_path__ + "static/media/drop.5b1134ca.png";